import { PhoneInput as CustomInput } from "react-international-phone";
import "react-international-phone/style.css";

interface IPhoneInputProps {
  value: string;
  setValue: (value: string) => void;
  errorMessage?: string;
  error?: boolean;
  disabled?: boolean;
  name?: string
  id?: string;
}

export default function PhoneInput(props: IPhoneInputProps) {
  const { name, value, setValue, error, errorMessage, disabled } = props;

  return (
    <div className="w-full">
      <CustomInput
        name={name}
        disabled={disabled}
        className={`shadow w-full py-2 px-4 rounded-[24px] flex  items-center gap-2 border bg-white duration-200 border-slate-300 ${props.error ? "!border-secondary" : "!border-slate-300"}`}
        inputClassName="py-2 w-full text-sm font-bold outline-none !border-none text-primary placeholder:text-assistant"
        defaultCountry="tr"
        preferredCountries={["tr", "us"]}
        value={value}
        onChange={(phone) => setValue(phone)}
      />

      {error && errorMessage && (
        <div className="text-secondary text-[12px] mt-1.5 pl-6">
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
}
